module.exports = __webpack_public_path__ + "685b06addad3f9ad8ab3a8700e33e5aa.svg";